/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/common/messages.ts" />
/// <reference path="../../components/controls/presets/presets-list.ts" />

module Meevo.Plugins.ActivityLog {
    'use strict';

    import IDataMaintenanceInfiniteList = Meevo.Components.BaseClasses.IDataMaintenanceInfiniteList;
    import PresetStatus = Meevo.Components.Controls.PresetStatus;
    import SalesTypeEnum = Meevo.Model.SalesTypeEnum;  
    import SortDirection = Meevo.Model.SortDirection;
    import DEFAULT_PRESET_LIST = Meevo.Components.Controls.DEFAULT_PRESET_LIST;
    import Messages = Meevo.Components.Common.Messages;
    import ChangedDateEnum = Meevo.Components.Controls.ChangedDateEnum;
    import BusyService = Meevo.Components.Busy.BusyService;
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;

    interface IParams {
        auditActivity: CategorySearchEnum,
        user: any,
        client: any,
        employee: Meevo.Model.Employee,
        purpose: number,
        filter: string,
        keyword: string,
        maintenanceMode: boolean,
        isGlobal: boolean,
        wildcardType: any,
        startDate: Date,
        endDate: Date
    }

    enum TransactionTypeEnum {
        Refund,
        GiftCard,
        OnHold,
        Void,
        Completed
    }

    enum TableHeaderEnum {
        DateTime,
        UserId,
        Description,
        Application
    }

    interface ICategory {
        value: CategorySearchEnum,
        label: string
    }

    interface IActivityLogRequest {
        criteria?: any;
        itemsPerPage: number;
        clientGlobalId?: string;
        asLocationId?: number;
        sortBy: string;
        sortDirection: SortDirection;
    }

    interface IActivityLogController {
        categories: Array<ICategory>;
        params: IParams;

        expandItem: (element: IActivityElement) => void;
        exportData: (activityType: CategorySearchEnum, auditDetails) => void;
        exportList: (loadedData: any) => void;
        loadActivity: (auditActivity: CategorySearchEnum) => void;
    }    

    declare let XLSX: any;

    class ParamsObject implements IParams {
        auditActivity: CategorySearchEnum;
        user: any;
        client: any;
        purpose: number | null;
        filter: string;
        keyword: string;
        maintenanceMode: boolean;
        timeType: TimeTypesEnum = TimeTypesEnum.FullDay;
        isGlobal: boolean;
        startTime: Date;
        endTime: Date;
        wildcardType: any;
        sortBy: string = 'DateUpdated';
        sortDirection: SortDirection = SortDirection.Descending;
        employee: any;
        endDate: Date;
        startDate: Date;
        transactionId: string;

        get onlyOneWeekAvailable(): boolean {
            return !!this.isSet(this.employee) || !!this.isSet(this.user);
        }

        get showEmployeeTypeAhead(): boolean {
            return this.auditActivity !== CategorySearchEnum.Clients && this.auditActivity !== CategorySearchEnum.DataChanges
        }

        constructor(params: ParamsObject = <ParamsObject>{}) {
            _.assign(this, params);
        }

        public getRequest(): IActivityLogRequest {
            this.filter = this.keyword; // For highlight. Highlight must appears after request
            return {
                criteria: {
                    ..._.pick(this,
                        'auditActivity',
                        'startDate',
                        'endDate',
                        'purpose',
                        'filter',
                        'maintenanceMode',
                        'isGlobal',
                        'wildcardType'
                    ),
                    employeeId: this.employee ? this.employee.id : null,
                    userId: this.user ? this.user.id : null,
                    clientId: this.client ? this.client.id : null,
                    startDate: moment(this.startDate).format().split('T')[0] + 'T' + moment(this.startTime).format().split('T')[1],
                    endDate: moment(this.endDate).format().split('T')[0] + 'T' + moment(this.endTime).format().split('T')[1]
                },
                itemsPerPage: 25,
                sortBy: this.sortBy,
                sortDirection: this.sortDirection
            }
        }

        public setToDefault() {
            this.auditActivity = CategorySearchEnum.DataChanges;
            this.timeType = TimeTypesEnum.FullDay;
            this.user = this.client = this.employee = null;
        }

        private isSet(data: any) {
            return data && data.id !== -1;
        }

    }

    class ActivityLogController implements IActivityLogController {

        static $inject = [
            '$scope',
            '$rootScope',
            '$state',
            'meevo.components.common.IdentityService',
            'meevo.components.common.SecurityService',
            'meevo.menuService',
            '$q',
            'meevo.components.modal.ModalService',
            '$mdDialog',
            'meevo.components.common.DataService',
            'meevo.components.common.DataExportService',
            '$translate',
            'meevo.AppSettings',
            'meevo.components.busy.BusyService',
            'meevo.plugins.activityLog.ActivityLogService',
            'meevo.plugins.activityLog.ExportDataService',
            '$timeout',
            'meevo.ContextParams'
        ];

        public defaultId: number = -1;
        public searchString: string = '';
        public searchText: string = '';
        public timeTypes: any = [
            { value: TimeTypesEnum.Custom, label: 'LABEL_CUSTOM' },
            {
                value: TimeTypesEnum.Morning,
                label: 'LABEL_MORNING',
                startTime: moment().startOf('day').milliseconds(0).toDate(),
                endTime: moment().startOf('day').add(12, 'hours').subtract(1, 's').milliseconds(0).toDate()
            },
            {
                value: TimeTypesEnum.Afternoon,
                label: 'LABEL_AFTERNOON',
                startTime: moment().startOf('day').add(12, 'hours').milliseconds(0).toDate(),
                endTime: moment().endOf('day').subtract(7, 'h').milliseconds(0).toDate()
            },
            {
                value: TimeTypesEnum.Evening,
                label: 'LABEL_EVENING',
                startTime: moment().endOf('day').subtract(7, 'h').add(1, 's').milliseconds(0).toDate(),
                endTime: moment().endOf('d').milliseconds(0).toDate()

            },
            {
                value: TimeTypesEnum.FullDay,
                label: 'LABEL_FULL_DAY',
                startTime: moment().startOf('d').milliseconds(0).toDate(),
                endTime: moment().endOf('d').milliseconds(0).toDate()
            }
        ];

        public categories: Array<ICategory> = [
            { value: CategorySearchEnum.All, label: 'LABEL_ALL_ACTIVITIES' },
            { value: CategorySearchEnum.AllPayroll, label: 'LABEL_ALL_PAYROLL' },    
            { value: CategorySearchEnum.Appointment, label: 'HEADER_APPOINTMENT' },
            { value: CategorySearchEnum.Clients, label: 'HERO_SUB_CLIENTS' },
            { value: CategorySearchEnum.Communications, label: 'LABEL_COMMUNICATIONS' },
            { value: CategorySearchEnum.DataChanges, label: 'LABEL_DATA_CHANGES' },
            { value: CategorySearchEnum.GiftCards, label: 'LABEL_GIFT_CARDS' },
            { value: CategorySearchEnum.Payroll, label: 'LABEL_PAYROL' },
            { value: CategorySearchEnum.PayrollData, label: 'LABEL_PAYROL_DATA' },
            { value: CategorySearchEnum.PayrollSettings, label: 'LABEL_PAYROL_SETTINGS' },
            { value: CategorySearchEnum.ReportScheduler, label: 'LABEL_REPORT_SCHEDULER' },
            { value: CategorySearchEnum.SecurityAudit, label: 'LABEL_SECURITY_AUDIT' },
            { value: CategorySearchEnum.Transaction, label: 'LABEL_TRANSACTION' }
        ];

        public dateRangeParams: IDateRangeParams = {
            minDate: moment().subtract(12, 'months').toDate(),
            presetList: [
                { name: 'LABEL_CUSTOM', status: PresetStatus.Custom },
                { name: 'LABEL_TODAY', status: PresetStatus.Today },
                { name: 'LABEL_YESTERDAY', status: PresetStatus.Yesterday },
                { name: 'LABEL_THIS_WEEK', status: PresetStatus.ThisWeek },
                { name: 'LABEL_LAST_WEEK', status: PresetStatus.LastWeek },
                { name: 'LABEL_PREVIOUS_TWO_WEEKS', status: PresetStatus.PreviousTwoWeeks },
                { name: 'LABEL_THIS_MONTH', status: PresetStatus.ThisMonth },
                { name: 'LABEL_LAST_MONTH', status: PresetStatus.LastMonth },
                { name: 'LABEL_THIS_QUARTER', status: PresetStatus.ThisQuarter },
                { name: 'LABEL_LAST_QUARTER', status: PresetStatus.LastQuarter },
                { name: 'LABEL_THIS_YEAR', status: PresetStatus.ThisYear },
                { name: 'LABEL_LAST_TWELVE_MONTHS', status: PresetStatus.LastTwelveMonths },
                { name: 'LABEL_LAST_YEAR', status: PresetStatus.LastYear }
            ],
            presetListOneWeek: [
                { name: 'LABEL_CUSTOM', status: PresetStatus.Custom },
                { name: 'LABEL_TODAY', status: PresetStatus.Today },
                { name: 'LABEL_YESTERDAY', status: PresetStatus.Yesterday },
                { name: 'LABEL_THIS_WEEK', status: PresetStatus.ThisWeek },
                { name: 'LABEL_LAST_WEEK', status: PresetStatus.LastWeek },
            ],
            selectedPreset: undefined,
            predefinedPresetStatus: PresetStatus.Today,
            predefinedPresetStatusEmployee: PresetStatus.ThisWeek,
            useCustomError: true
        };

        public sortByValues = {
            [TableHeaderEnum.DateTime]: 'dateUpdated',
            [TableHeaderEnum.UserId]: 'modifiedByUserId',
            [TableHeaderEnum.Description]: 'description',
            [TableHeaderEnum.Application]: 'applicationName'
        };

        public defaultPeopleValues = {
            user: { displayName: this.t('LABEL_ALL_USERS'), id: this.defaultId },
            employee: { displayName: this.t('LABEL_ALL_EMPLOYEES', { employee: 'Employee' }), id: this.defaultId },
            client: { displayName: this.t('LABEL_ALL_CLIENTS'), id: this.defaultId },
        };        

        public sortField: TableHeaderEnum = TableHeaderEnum.DateTime;
        public params: ParamsObject;
        public arrayResults: IDataMaintenanceInfiniteList;
        public todayDay = new Date();
        public criteriaTypeAhed = {
            isGlobal: false,
            ShowEmployeesOnly: 0,
            includeFullAccess: true
        };
        public employeesCriteria = {
            isGlobal: false,
            ShowEmployeesOnly: 0,
            includeFullAccess: true,
            includeActive: true,
            includeInactive: true,
            includeDeleted: true,
            includeTerminated: true,
            includeTerminatedToDate: moment().subtract(1, 'year').format()
        };
        public request: IActivityLogRequest;
        public showFilter: boolean = true;
        public isChangedTimeBySelect: boolean = false;
        public isWasFirstTimeChanged: boolean = false;
        public lastSelectedAuditId: Guid;
        public isFilterSearchedList: boolean = true;
        public filteredArrayResults: Array<any>;
        public scrolledItemIndex: number = 0;
        public elementScrollToId: string;
        public elementScrollTo: any;
        public indexOfNeededElement: number;
        public detailData: any;
        public auditDetail = [];
        private throttle = false;
        private auditDetailsResults: any;
        public pagination: IPagination = {
            itemsPerPage: 20,
            pageNumber: 0
        }

        constructor(protected $scope: angular.IScope,
            protected $rootScope: ng.IRootScopeService,
            protected $state: angular.ui.IState,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            menuService: Meevo.MenuService,
            protected $q: angular.IQService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected $mdDialog: ng.material.IDialogService,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected dataExportService: Meevo.Components.Common.IDataExportService,
            protected $translate: angular.translate.ITranslateService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected busyService: BusyService,
            protected activityLogService: IActivityLogService,
            protected exportDataService: IExportDataService,
            protected $timeout: angular.ITimeoutService,
            protected contextParams: Meevo.ContextParamsService
        ) {
            this.initActivityLog();
        }

        private initActivityLog(): void {
            this.params = new ParamsObject();            
            this.initWatches();
            if (this.contextParams && this.contextParams.params && this.contextParams.params.filterParams) {
                this.$timeout(() => {
                    this.applyParamsToContext(this.contextParams.params.filterParams);
                });
            }

            this.$scope.$on(Meevo.Components.Common.Messages.APPLY_PARAMS_TO_CONTEXT, (event, state, params) => {
                if (state.name !== this.appSettings.ROUTE_NAMES.activityLog || !params || !params.filterParams) {
                    return;
                }

                this.applyParamsToContext(params.filterParams);
            });
        }

        private initWatches() {
            this.$scope.$watch(() => this.params.timeType, (newValue, oldValue) => {
                if (newValue === oldValue || newValue === TimeTypesEnum.Custom) return;

                this.isChangedTimeBySelect = true;

                this.onTimeTypeChange(newValue);
            });

            const onCangedTime = (newValue, oldValue) => {
                this.$timeout(() => {
                    this.isChangedTimeBySelect = false;
                }, 1000);

                // Meevo-time-frame returns time with milliseconds but we operate without it
                const isValueSame = moment(newValue).milliseconds(0).isSame(moment(oldValue).milliseconds(0));
                if (!oldValue || isValueSame || this.isChangedTimeBySelect) return;

                this.params.timeType = TimeTypesEnum.Custom;
            };

            this.$scope.$watch(() => this.params.startTime, onCangedTime);
            this.$scope.$watch(() => this.params.endTime, onCangedTime);
        }

        /**
         * Load Audit information
         * @param auditActivity
         */
        loadActivity(auditActivity: CategorySearchEnum): void {
            this.lastSelectedAuditId = Guid.empty;
            
            this.busyService.start();
            let postSearchCallback: Function = null;
            if (this.searchText && this.searchText.length > 0) {
                this.applySearchText('');
                postSearchCallback = () => {
                    this.applySearchText(this.searchText, true);
                }
            }
            this.arrayResults = new Meevo.Components.BaseClasses.PagedResults(this.dataService, 'ActivityLog/Audit', postSearchCallback);
            this.arrayResults.initSearch(this.getRequest(auditActivity)).finally(() => {
                this.busyService.stop();
            });
        }      

        /**
         * Open modal with detailed information
         * @param {IActivityElement} element
         */
        expandItem(element: IActivityElement): void {
            this.lastSelectedAuditId = element.id;
            let templateUrl: string = (function getTemplateUrl(element) {
                if (element.isTransaction) return 'app/plugins/activityLog/modals/transactionsAuditModal.html';
                return 'app/plugins/activityLog/modals/expandedItem.html';
            })(element);
            this.throttle = false;
            this.pagination.pageNumber = 0;

            this.detailData = {
                internalSessionId: element.internalSessionId,
                id: element.id,
                entityId: element.entityId ? element.entityId : null
            };

            this.busyService.start();
            this.prepareScopeData(element).then(modalScope => {
                let options: Meevo.Components.Modal.IModalOptions = {
                    clickOutsideToClose: true,
                    templateUrl: templateUrl,
                    scope: modalScope
                };

                this.modalService.showCustom(options);
            }).finally(() => {
                this.busyService.stop();
            });
        }

        /**
         * Return all filters to default values and clear any loaded results within Activity Log
         */
        resetFilters(): void {
            // Revert data in filter
            this.params.setToDefault();
            this.dateRangeParams.selectedPreset = _.find(this.dateRangeParams.presetList, (preset: IPresetItem) => preset.status === PresetStatus.Today);

            // Revert filtering data
            this.searchString = this.searchText = '';
            this.revertFilteringData();

            // Clear loaded results
            if (angular.isDefined(this.arrayResults) || this.arrayResults) this.arrayResults = null;            
        }

        /**
         * Export list of activities to csv file
         * @param {any} loadedData
         */
        exportList(loadedData): void {
            let preparedData = loadedData.reduce(function (previousValue, currentValue) {
                previousValue.push(...currentValue);
                return previousValue;
            }, []);

            let workSheet = this.exportDataService.getAuditList(preparedData);
            this.dataExportService.generateFile(XLSX.utils.sheet_to_csv(workSheet), 'activityLog_export', Meevo.Components.Common.FileTypeEnum.CSV);
        }

        /**
         * Export expanded item to csv
         * @param {CategorySearchEnum} activityType
         * @param {any} auditDetails
         */
        exportData(activityType: CategorySearchEnum, auditDetails): void {
            let workSheet = this.exportDataService.getWorkSheet(activityType, auditDetails);
            this.dataExportService.generateFile(XLSX.utils.sheet_to_csv(workSheet), 'activityLog_export', Meevo.Components.Common.FileTypeEnum.CSV);
        }

        /**
         * Sort data in list of activity on a main screen
         * @param {TableHeaderEnum} tableHeader
         */
        private sortData(tableHeader: TableHeaderEnum): void {
            // Set sorting option for UI part            
            if (this.sortField !== tableHeader) this.params.sortDirection = SortDirection.Ascending;
            else this.params.sortDirection = +!this.params.sortDirection;

            // Saved sorting data for future requests
            this.sortField = tableHeader;
            this.params.sortBy = this.sortByValues[tableHeader];

            // It checks if request is made earlier
            if (angular.isDefined(this.arrayResults) && this.arrayResults) {
                this.loadActivity(this.params.auditActivity)
            }
        }

        /**
         * Open transaction editor
         * @param {string} transactionNumber
         */
        private openTransactionEditor(transactionNumber: string): void {
            if (!transactionNumber || transactionNumber === 'N/A') return;

            // Build params for loading transaction in editor
            let stateParams = {
                transactionId: transactionNumber,
                includeActive: true,
                includeCompleted: true,
                includeOnHold: false,
                includeRefunded: true,
                includeVoided: true
            };
            this.$rootScope.$broadcast(Messages.GOTO_STATE, {
                stateName: this.appSettings.ROUTE_NAMES.transactionEditor,
                stateParams: stateParams,
                securityKey: Meevo.Components.Common.SecurityKeys.REGISTER_TRANSACTIONEDITOR + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
            });
            this.closeModal();
        }

        /**
         * Callback for on-enter event in search inputy
         * @param {string} searchText
         * @param {boolean} isApplyScope
         */
        private applySearchText(searchText: string, isApplyScope?: boolean): void {
            this.searchString = searchText;

            if (!searchText) {
                this.revertFilteringData();
                return;
            }

            this.scrolledItemIndex = 0;
            this.filterSearchedItems();
            this.scrollDown();
            if (isApplyScope) this.$scope.$apply();
        }

        scrollUp() {
            if (this.filteredArrayResults.length && this.scrolledItemIndex) {
                const scrolledItemIndex = this.scrolledItemIndex != 0 ? this.scrolledItemIndex - 1 : this.scrolledItemIndex;

                const itemId = this.filteredArrayResults[scrolledItemIndex].id;

                this.assignNeededElement(itemId, this.arrayResults.getAllItems());

                this.scrolledItemIndex--;
            }
        }

        scrollDown() {
            if (this.filteredArrayResults.length) {
                const indexInFilteredArrayResults = this.activityLogService.getIndexInFilteredArrayResults(this.filteredArrayResults, this.elementScrollToId);

                if (indexInFilteredArrayResults == this.filteredArrayResults.length - 1) {
                    this.filteredArrayResults = this.activityLogService.getFilteredArrayResults(this.searchString, this.arrayResults.getAllItems());
                }

                if (this.scrolledItemIndex == this.filteredArrayResults.length) {
                    this.scrolledItemIndex = 0;
                    this.elementScrollTo = null;
                }

                if (this.scrolledItemIndex == 0 && !this.elementScrollTo) {
                    this.scrolledItemIndex = 0
                } else {
                    this.scrolledItemIndex++;
                }

                const scrolledItemIndex = this.scrolledItemIndex == this.filteredArrayResults.length ? this.scrolledItemIndex + 1 : this.scrolledItemIndex;

                const itemId = this.filteredArrayResults[scrolledItemIndex].id;

                this.assignNeededElement(itemId, this.arrayResults.getAllItems());


            }
        }

        assignNeededElement(itemId: string, arrayResultsAllItems: Array<any>) {
            const elementAndIndex = this.activityLogService.getElementAndIndexInArrayResults(itemId, arrayResultsAllItems);

            this.indexOfNeededElement = elementAndIndex.indexOfElement;
            this.elementScrollTo = elementAndIndex.element;
            this.elementScrollToId = elementAndIndex.element.id;
        }

        filterSearchedItems() {
            this.filteredArrayResults = this.activityLogService.getFilteredArrayResults(this.searchString, this.arrayResults.getAllItems());
        }

        /**
         * Close modal
         */
        private closeModal(): void {
            this.pagination.pageNumber = 0;
            this.throttle = false;
            this.$mdDialog.cancel();
        };

        /**
         * Close current tab
         * */
        private closeContext(): void {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state['current'], null);
        }

        /**
         * Callback for change event for time frame to change time value
         * @param {TimeTypesEnum} timeType
         */
        private onTimeTypeChange(timeType: TimeTypesEnum): void {
            for (let item of this.timeTypes) {
                if (item.value === timeType) {
                    this.params.startTime = item.startTime;
                    this.params.endTime = item.endTime;
                    break;
                }
            }
        }

        /**
         * Callback for date filter
         * @param {ChangedDateEnum} changedDate
         * @param {any} changedValue
         */
        private onDateFilterChanged(changedDate: ChangedDateEnum, changedValue?: any): void {
            if (!this.params.onlyOneWeekAvailable) return;

            switch (this.dateRangeParams.selectedPreset.status) {
           
                case PresetStatus.ThisWeek:
                    this.params.endDate = moment().startOf('d').milliseconds(0).toDate();
                    break;
                default: break;
            }
        }

        private prepareScopeData(element: IActivityElement) {
            // Todo: added promise type
            let detailsPromise;
            let modalScope = this.$scope.$new(true);
            // If activity type is all, determine the type using element info
            let activityType = this.params.auditActivity === CategorySearchEnum.All ? this.activityLogService.getTypeOfActivity(element) : this.params.auditActivity;
            modalScope['closeModal'] = this.closeModal.bind(this);
            modalScope['descriptionClicked'] = this.descriptionClicked.bind(this);
            modalScope['isDescriptionLinked'] = this.isDescriptionLinked.bind(this);
            modalScope['exportData'] = this.exportData.bind(this, activityType);
            modalScope['expandItem'] = this.expandItem.bind(this);
            modalScope['scrollCallback'] = this.scrollCallback.bind(this);

            if (element.isTransaction) {
                modalScope['openTransactionEditor'] = this.openTransactionEditor.bind(this);
                modalScope['saleLineHasSplitCommission'] = this.activityLogService.hasSplitCommission.bind(this);
                modalScope['transactionTypeEnum'] = this.transactionTypeEnum;
                modalScope['discountTypeEnum'] = this.discountTypeEnum;
                modalScope['saleStateEnum'] = this.saleStateEnum;
            }

            detailsPromise = element.isTransaction ?
                this.activityLogService.getTransactionDetailedInformation(element) :
                this.activityLogService.getAuditDetailedInformation(element, activityType, this.pagination);

            return detailsPromise.then(auditDetail => {
                this.auditDetail = auditDetail;
                _.extend(
                    modalScope,
                    this.auditDetail,
                    this.activityLogService.getExpandModalConfig(element)
                );
                return modalScope;
            });
        }

        private isBlockScheduleLink(auditDetails) {
            return auditDetails.nounId === Model.NounEnum.BlockSchedule;
        }

        isDescriptionLinked(auditDetails) {
            return this.isBlockScheduleLink(auditDetails);
        }

        descriptionClicked(auditDetails){
            if (this.isBlockScheduleLink(auditDetails)) {
                this.closeModal();
                var stateParams = {
                    targetState: Meevo.Model.MaintenanceFormVisualState.Detail,
                    actionState: Meevo.Model.MaintenanceFormState.Readonly,
                    id: auditDetails.entityId,
                };

                this.$rootScope.$broadcast("gotoState", {
                    stateName: this.appSettings.ROUTE_NAMES.standingBlocks,
                    stateParams: stateParams
                });
            }
        }

        scrollCallback() {
            const historyLength = this.auditDetail['auditDetails'].history.length;
            const isHasMore = this.activityLogService.count - historyLength;

            if (!this.throttle && isHasMore){
                this.throttle = true;
                this.pagination.pageNumber += 1;
                this.busyService.start();
                this.activityLogService.getAuditDataApi(this.detailData, this.pagination).then(auditDetails => {
                    this.throttle = Boolean(auditDetails.history.length % 20);
                    this.auditDetail['auditDetails'].history = [...this.auditDetail['auditDetails'].history, ...auditDetails.history];
                }).finally(() => {
                    this.busyService.stop();
                })
            }
        }

        private getRequest(auditActivity: CategorySearchEnum): IActivityLogRequest {            
            // Data Changes will not show results for Page View & Clicked Events related activities as these events don't contain any data.  
            this.params.purpose = auditActivity === CategorySearchEnum.DataChanges ? 1 : null;

            let request: IActivityLogRequest = this.params.getRequest();

            if (auditActivity === CategorySearchEnum.PayrollSettings) request.criteria.employeeId = -1;
            if (this.isIgnoreClient) request.criteria.clientId = -1;
            if (this.params.transactionId) request.criteria.transactionId = this.params.transactionId

            return request;
        }

        private toggleFilter = () => {
            this.showFilter = !this.showFilter;
        }

        private displayFilters = (displayFilter) => {
            this.showFilter = displayFilter;
        }

        private t(key: string, parameters?: any): string {
            return this.$translate.instant(key, parameters);
        }

        /**
         * Search button will be disabled if it's true
         */
        private isLoadedData(): boolean {
            return !!this.arrayResults;
        }

        /**
         * Zeroing all data related to filtering
         */
        private revertFilteringData() {
            this.indexOfNeededElement = null;
            this.elementScrollTo = null;
            this.elementScrollToId = null;
            this.filteredArrayResults = [];
        }

        private applyParamsToContext(params: any) {
            let postLoadCallback: Function;

            this.resetFilters();

            if (params.postFilter && params.postFilter.length > 0) {
                this.searchText = params.postFilter;
            }

            this.dateRangeParams.selectedPreset = _.find(this.dateRangeParams.presetList, 
                (preset: IPresetItem) => preset.status === PresetStatus.Custom);
            params.startTime = params.startDate.getTime();
            params.endTime = params.endDate.getTime();

            _.extend(this.params, params);
                
            const category = this.params.auditActivity || CategorySearchEnum.All;

            if(params.startTime < moment().subtract(1, 'years')){
                this.modalService.alert('MESSAGE_MEEVO_STORES_ACTIVITY')
                return;
            }

            this.loadActivity(category);
            this.displayFilters(false);
            this.isFilterSearchedList = true;
        }

        preProcessData(response: any[], request) {
            response.forEach(item => {
                if(item.objectState == ObjectStateEnum.Inactive) {
                    item.applyStyle = 'inactive'
                } else if (item.objectState == ObjectStateEnum.Deleted) {
                    item.applyStyle = 'deleted'
                }
            })
        }

        get categorySearchEnum(): any {
            return CategorySearchEnum
        }

        get saleStateEnum(): any {
            return Meevo.Model.SaleStateEnum;
        }

        get discountTypeEnum(): any {
            return Meevo.Model.DiscountTypeEnum;
        }

        get transactionTypeEnum(): any {
            return TransactionTypeEnum;
        }

        get tableHeaderEnum(): any {
            return TableHeaderEnum;
        }

        get sortDirection(): any {
            return SortDirection;
        }

        get isIgnoreClient(): any {
            return this.activityLogService.isPayrollActivity(this.params.auditActivity) || this.params.auditActivity === this.categorySearchEnum.ReportScheduler;
        }

        get selectedPreset() {
            if (!this.dateRangeParams.selectedPreset) return;

            const presetList = this.params.onlyOneWeekAvailable ? this.dateRangeParams.presetListOneWeek : this.dateRangeParams.presetList;

            // Needed after switching from All employee to Employee selected modes or vice versa
            if (!_.contains(presetList, this.dateRangeParams.selectedPreset)) {
                this.dateRangeParams.selectedPreset = this.activityLogService.getNewSelectedPresetStatus(this.dateRangeParams, presetList, this.params.onlyOneWeekAvailable);

                // Emitted changes of values in date filters after switching from All Employee mode
                //if (this.dateRangeParams.selectedPreset.status === PresetStatus.Custom && this.params.onlyOneWeekAvailable) this.onDateFilterChanged(ChangedDateEnum.From)
            }

            return this.dateRangeParams.selectedPreset;
        }

        set selectedPreset(value: IPresetItem) {
            this.dateRangeParams.selectedPreset = value;
        }

    }

    angular.module('meevo.plugins.activityLog')
        .controller('meevo.plugins.activityLog.ActivityLogController', ActivityLogController);
}

/*  .Add<ClientActivityLogPage>("/ActivityLog/Client/List", ApplyTo.Get | ApplyTo.Post)
    .Add<ClientActivityLogCount>("/ActivityLog/Client/Count", ApplyTo.Get | ApplyTo.Post)
    .Add<ClientActivityLogGet>("/ActivityLog/Client/{Id}", ApplyTo.Get)
    .Add<DataChangesActivityLogPage>("/ActivityLog/DataChange/List", ApplyTo.Get | ApplyTo.Post)
    .Add<DataChangesActivityLogCount>("/ActivityLog/DataChange/Count", ApplyTo.Get | ApplyTo.Post)
    .Add<DataChangesActivityLogGet>("/ActivityLog/DataChange/{Id}", ApplyTo.Get)
    .Add<TransactionsActivityLogPage>("/ActivityLog/Transaction/List", ApplyTo.Get | ApplyTo.Post)
    .Add<TransactionsActivityLogCount>("/ActivityLog/Transaction/Count", ApplyTo.Get | ApplyTo.Post)
    .Add<TransactionsActivityLogGet>("/ActivityLog/Transaction/{Id}", ApplyTo.Get)
    .Add<EmployeeTrackingActivityLogPage>("/ActivityLog/EmployeeTracking/List", ApplyTo.Get | ApplyTo.Post)
    .Add<EmployeeTrackingActivityLogCount>("/ActivityLog/EmployeeTracking/Count", ApplyTo.Get | ApplyTo.Post)
    .Add<EmployeeTrackingActivityLogGet>("/ActivityLog/EmployeeTracking/{Id}", ApplyTo.Get)
    .Add<SecurityAuditActivityLogPage>("/ActivityLog/SecurityAudit/List", ApplyTo.Get | ApplyTo.Post)
    .Add<SecurityAuditActivityLogCount>("/ActivityLog/SecurityAudit/Count", ApplyTo.Get | ApplyTo.Post)
    .Add<SecurityAuditActivityLogGet>("/ActivityLog/SecurityAudit/{Id}", ApplyTo.Get)

*/
